export const createDtoBusquedaTurnosDisponibles = ({
  familiar,
  fechaDesde,
  gruposMedico,
  particular,
  videoAtencion,
  conContraste,
  OsAlternativa,
}) => {
  let dtoEstudioTurnos = {
    amamantando: false,
    conContraste: conContraste,
    contrasteReciente: false,
    diabeticoHipertenso: false,
    embarazada: false,
    fechaDesde: fechaDesde,
    GruposMedico: [
      {
        Id: gruposMedico.Id,
        Descripcion: gruposMedico.Descripcion,
        Particular: particular,
      },
    ],
    idGrupoMedico: gruposMedico.Id,
    idObraSocial: familiar?.obraSocial,
    idPlan: familiar?.idPlan,
    insRenal: false,
    marcapasos: false,
    operador: "",
    pag: 1200,
    particular: particular,
    peso: 0,
    rec: 0,
    videoAtencion: videoAtencion,
    OsAlternativa: OsAlternativa,
  };

  return dtoEstudioTurnos;
};
